<template>
  <div class="popup-form archive-detail-popup">
    <div class="content-form-popup archive-detail-content">
      <div class="archive-detail-header">
        <button class="detail-back" type="button" aria-label="Späť" @click="closePopup">‹</button>
        <div>
          <span>Iný dôvod neúspechu</span>
          <h2>Čo konkrétne rozhodlo?</h2>
          <p>Tento detail sa zobrazí v štatistikách dôvodov archivácie.</p>
        </div>
      </div>

      <div class="detail-choice-list">
        <button
          v-for="choice in detailChoices"
          :key="choice.value"
          class="detail-choice"
          type="button"
          @click="finishArchive(choice.value)"
        >
          <span>{{ choice.label }}</span>
          <span class="detail-check">✓</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArchiveClientDetailPopUp",
  props: {
    payload: Object,
  },
  data: () => ({
    detailChoices: [
      {value: "low_mortgage", label: "Príliš nízka hypotéka"},
      {value: "not_available", label: "Nedovolal som sa"},
      {value: "not_solvable", label: "Neriešiteľný prípad"},
      {value: "old_lead_excluded", label: "Starý lead mimo štatistiky"},
    ],
  }),
  methods: {
    finishArchive(reason) {
      this.$store.commit("popupManagerState/setPopupSuccessResult", {
        client: this.payload.client,
        reason,
      });
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    closePopup() {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
};
</script>

<style scoped lang="scss">
.archive-detail-content {
  padding: 28px;
}

.archive-detail-header {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}

.detail-back {
  display: grid;
  width: 36px;
  height: 36px;
  padding: 0;
  place-items: center;
  border: 1px solid var(--app-border);
  border-radius: 11px;
  background: var(--app-surface-muted);
  color: var(--app-primary);
  font-size: 24px;
  cursor: pointer;
}

.archive-detail-header span {
  color: var(--app-primary);
  font-size: 9px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .08em;
}

.archive-detail-header h2 {
  margin: 3px 0 4px;
  color: var(--app-text);
  font-size: 20px;
  font-weight: 800;
}

.archive-detail-header p {
  margin: 0;
  color: var(--app-text-muted);
  font-size: 10px;
}

.detail-choice-list {
  display: grid;
  gap: 9px;
}

.detail-choice {
  display: flex;
  width: 100%;
  min-height: 58px;
  padding: 10px 13px 10px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid var(--app-border);
  border-radius: 13px;
  background: var(--app-surface-muted);
  color: var(--app-text);
  font-size: 11px;
  font-weight: 750;
  text-align: left;
  cursor: pointer;
  transition: border-color .18s ease, background .18s ease, transform .18s ease;
}

.detail-choice:hover {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
  transform: translateY(-1px);
}

.detail-check {
  display: grid;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  place-items: center;
  border-radius: 9px;
  background: var(--app-surface);
  color: var(--app-primary);
}
</style>
